import React from 'react';
import { useTranslation } from 'react-i18next';

const YearSelector = ({ value, onChange, error }) => {
  const { t } = useTranslation();

  const handleYearChange = (e) => {
    const newYear = e.target.value.toString();
    onChange(newYear);
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 120 }, (_, i) => currentYear - i);
  return (
    <div className='formFieldContainer'>
    <label className='formLabel'>
        {t('form.dateOfBirth')}
        <select className='textField-select'
            name="dateOfBirth"
            value={value} 
            onChange={handleYearChange}>
            <option value="">{t('form.select')}</option> {/* Opción vacía */}
            {years.map((year) => (
                <option key={year} value={year}>
                {year}
                </option>
            ))}
        </select>
    {error && <span className="errorMessage">{error}</span>}
    </label>
    </div>
  );
};

export default YearSelector;
